export const WIDTH_PX = 150
export const HEIGHT_PX = 36
export const ARROW_HEIGHT_PX = 10
export const SHADOW_WIDTH_PX = 4
export const FONT_SIZE = 16
export const FONT_SIZE_MARKED = 20
